import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import { toast } from 'react-toastify';
import apiInstance from '../../Apis/Axios';
import { UploadImage } from '../ShareSlice/shareApi';
import { createImgObj, getSelfie } from '../CompanyEmployees/CompanyEmployeesApi';
import { t } from 'i18next';
import {accessMethodModel} from "../../enums/accessMethodEnum";
import { COMPANY_SERVICE, DOCUMENT_SERVICE, EXTRA_DATA_SERVICE, IMAGE_SERVICE, ORDER_SERVICE, STATUS_SERVICE, SUPPLIER_EMPLOYEE_SERVICE, SUPPLIER_SERVICE, USER_SERVICE, VEHICLE_SERVICE} from "../EndPoints";
import { TABLES } from '../../Apis/Tables';


// /get-by-user-id/{userId}provider-module in provider-controller
export const GetProvidersByUserId = createAsyncThunk(
    'providers/getProvidersByUserId',
    async (params) => {
        const { userId } = params;
        const result = await apiInstanceV2
            .get(`${SUPPLIER_SERVICE.getProvidersByUserId}${userId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetOrderDetailsV1 = createAsyncThunk('providers/getOrderDetailsV1', async (id) => {
    const result = await apiInstanceV2
        .get(ORDER_SERVICE.getOrderDetailsV1 + id)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// complete order get all provider vehicle list
export const GetAllProviderVehicleListDown = createAsyncThunk(
    'providers/getAllProviderVehicleListDown',
    async (params) => {
        // params here is providerId

        const result = await apiInstanceV2
            .post(`supplier-vehicle-service/get-all/by-supplier-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const CompleteOrderProvider = createAsyncThunk(
    'providers/completeOrderProvider',
    async (params) => {
        const result = await apiInstanceV2
            .put(`${ORDER_SERVICE.completeOrderProvider}${params?.orderId}`, params?.data)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// create relation between provider and user
//corporate-user-pre-prod-v1/provider-employee-service/create
export const CreateSupplierEmployee = createAsyncThunk(
    'providers/createSupplierEmployee',
    async (params, { dispatch }) => {
        let result = await apiInstanceV2
            .post(SUPPLIER_EMPLOYEE_SERVICE.createSupplierEmployee, params?.data)
            .then(function (response) {
                const imgData = {
                    user: {
                        id: response?.data?.data?.userId,
                    },
                    accessMethod: { id: accessMethodModel.FACE_RECOGNITION.id },
                    description: 'Face recognition',
                };
                // want to update or create image
                if (params?.file) {
                    dispatch(
                        createImgObj({
                            ...imgData,
                            file: params?.file,
                        }),
                    );
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get supplier info by id
export const GetSupplierInfoById = createAsyncThunk(
    'contractor/getSupplierInfoById',
    async (params) => {
        const result = await apiInstance
            .get(`${SUPPLIER_EMPLOYEE_SERVICE.getSupplierInfoById}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// details of provider employee
export const GetProviderEmployeeDetail = createAsyncThunk(
    'providers/getProviderEmployeeDetail',
    async (params) => {
        const result = await apiInstanceV2
            .get(`${SUPPLIER_EMPLOYEE_SERVICE.getProviderEmployeeDetail}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// get single user data
export const GetSingleProvider = createAsyncThunk(
    'providers/getSingleProvider',
    async (params) => {
        const result = await apiInstanceV2
            .get(`${USER_SERVICE.getSingleProvider}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//update provider employee
export const UpdateSupplierEmployee = createAsyncThunk(
    'providers/updateSupplierEmployee',
    async (params, { dispatch }) => {
        const { setModified, data, updateImage, file } = params;

        try {
            const response = await apiInstance.put(
                SUPPLIER_EMPLOYEE_SERVICE.updateSupplierEmployee,
                data
            );

            const userId = response?.data?.data?.userId;

            const imgData = {
                user: { id: userId },
                accessMethod: { id: accessMethodModel.FACE_RECOGNITION.id },
                description: 'Face recognition',
            };

            // --- Image handling ---
            if (updateImage && file) {
                const {
                    payload: {
                        data: { data: selfie },
                    },
                } = await dispatch(getSelfie(userId));
                await dispatch(UploadImage({ id: selfie?.id, file }));
            } else if (!updateImage && file) {
                await dispatch(createImgObj({ imgData, file }));
            }

            setModified(true);

            return {
                data: response.data,
                status: response.status,
            };
        } catch (error) {
            return {
                data: error?.response?.data,
                status: error?.response?.status,
            };
        }
    }
);

// download image
export const DownloadProviderImage = createAsyncThunk(
    'providers/downloadProviderImage',
    async (params) => {
        const result = await apiInstanceV2
            .get(IMAGE_SERVICE.downloadProviderImage(params?.id, params.option), {
                responseType: 'blob',
            })
            .then(function (response) {
                const extension = params?.type?.split('.')?.pop();
                const fileName = params?.type?.split('.')?.shift();

                const url = window?.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${fileName}.${extension}`); // or any other extension
                document.body.appendChild(link);
                link.click();
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// create document exernal value
export const CreateToExternal = createAsyncThunk(
    'providers/createToExternal',
    async (params) => {
        const result = await apiInstanceV2
            .post(DOCUMENT_SERVICE.createToExternal, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// set document exernal value
export const SetToExternal = createAsyncThunk('providers/setToExternal', async (params) => {
    const result = await apiInstanceV2
        .put(DOCUMENT_SERVICE.setToExternal, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// create a vehicle and relationship with provider
export const CreateVehicleAndRelationSupplier = createAsyncThunk(
    'providers/createVehicleAndRelationSupplier',
    async (params, { dispatch }) => {
        const result = await apiInstanceV2
            .post(`${VEHICLE_SERVICE.createVehicleAndRelationSupplier}${sessionStorage.getItem('providerId')}`, params?.vehicleData)
            .then(function (response) {
                const imgData = {
                    vehicle: {
                        id: response?.data?.data?.vehicle?.id,
                    },
                    accessMethod: {
                        id: '5',
                    },
                    description: 'Face recognition',
                };
                // want to update or create image
                if (params?.imageFile) {
                    dispatch(UploadProviderVehicleImage({ imgData, file: params?.imageFile }));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// upload image
export const UploadProviderVehicleImage = createAsyncThunk(
    'providers/uploadProviderVehicleImage',
    async (params, { dispatch }) => {
        const result = await apiInstanceV2
            .post(VEHICLE_SERVICE.uploadProviderVehicleImage, params?.imgData)
            .then(function (response) {
                const formData = new FormData();
                formData.append('id', response?.data?.data?.id);
                formData.append('option', 'vehicle');
                formData.append('file', params?.file);
                dispatch(UploadImage(formData));
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// get single user data
export const GetSingleProviderVehicle = createAsyncThunk(
    'providers/getSingleProviderVehicle',
    async (params) => {
        const result = await apiInstanceV2
            .get(`${VEHICLE_SERVICE.getSingleProviderVehicle}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// get vehicle Status list

export const GetProviderVehicleStatus = createAsyncThunk(
    'providers/getProviderVehicleStatus',
    async (params) => {
        const result = await apiInstanceV2
            .get(STATUS_SERVICE.getProviderVehicleStatus)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// vehicle details pages
export const GetProviderVehicleDetail = createAsyncThunk(
    'providers/getProviderVehicleDetail',
    async (params) => {
        const result = await apiInstanceV2
            .get(`supplier-vehicle-service/company/get-by-vehicle-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// update provider employee
export const UpdateProviderVehicleData = createAsyncThunk(
    'providers/updateProviderVehicleData',
    async (params, { dispatch }) => {
        const result = await apiInstanceV2
            .put(VEHICLE_SERVICE.updateProviderVehicleData, params?.data)
            .then(function (response) {
                const imgData = {
                    vehicle: {
                        id: response?.data?.data?.vehicle?.id || response?.data?.data?.id,
                    },
                    accessMethod: {
                        id: '5',
                    },
                    description: 'Face recognition',
                };
                // want to update or create image
                if (params?.imageFile != '') {
                    dispatch(UploadProviderVehicleImage({ imgData, file: params?.imageFile }));
                }

                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);


// create document exernal value
export const CreateToExternalVehicle = createAsyncThunk(
    'providers/createToExternalVehicle',
    async (params, { dispatch }) => {
        const result = await apiInstanceV2
            .post('document-service/supplier-vehicle/create ', params?.data)
            .then(function (response) {
                if (params?.file) {
                    const formData = new FormData();
                    formData.append('id', response?.data?.data?.id);
                    formData.append('option', 'supplier_vehicle_document');
                    formData.append('file', params?.file);
                    dispatch(UploadImage(formData));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// set document exernal value
export const SetToExternalVehicle = createAsyncThunk(
    'providers/setToExternalVehicle',
    async (params) => {
        const result = await apiInstanceV2
            .put('document-service/supplier-vehicle/set-comment', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// user doc for provider

// get user docs
export const GetUserDocuments = createAsyncThunk(
    'providers/getUserDocuments',
    async (params) => {
        // params here is userId
        const result = await apiInstanceV2
            .get(`${DOCUMENT_SERVICE.getUserDocuments}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// user profile extra data

export const GetUserExtraData = createAsyncThunk(
    'providers/getUserExtraData',
    async (params) => {
        // params here is userId

        const result = await apiInstanceV2
            .get(`${EXTRA_DATA_SERVICE.getUserExtraData}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// company restriction for user data
export const GetUserCompanyRestrictionData = createAsyncThunk(
    'providers/getUserCompanyRestrictionData',
    async (params) => {
        const result = await apiInstanceV2
            .get(COMPANY_SERVICE.getUserCompanyRestrictionData)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// unlink device user profile
//susan
export const UnlinkUserDevice = createAsyncThunk(
    'providers/unlinkUserDevice',
    async (params) => {
        //prams here is id
        let result = await apiInstanceV2
            .put(`${USER_SERVICE.unlinkUserDevice}${params}`)
            .then(function (response) {
                toast.success(t('has_been_unlinked_successfully'));
                return response;
            })
            .catch(function (error) {
                toast.error(t('error_unlinking').toUpperCase());
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// update provider employee

// get single user data
export const GetSingleUserProvider = createAsyncThunk(
    'providers/getSingleUserProvider',
    async (params) => {
        const result = await apiInstanceV2
            .get(`${USER_SERVICE.getSingleUserProvider}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// Update User
export const UpdateProviderExtraData = createAsyncThunk(
    'providers/updateProviderExtraData',
    async (params) => {
        const { id, body } = params;

        const result = await apiInstanceV2
            .put(`${EXTRA_DATA_SERVICE.updateProviderExtraData}${id}`, body)
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                    toast.success('Extra data updated');
                }
                return response;
            })
            .catch(function (error) {
                toast.error(error?.response?.data?.message);
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);



// ################  user Document status 3 ###################

// get all supplier document by it id
export const GetAllSupplierDocumentsById = createAsyncThunk(
    'providers/getAllSupplierDocumentsById',
    async (params) => {
        const result = await apiInstance
            .get(`${DOCUMENT_SERVICE.getAllSupplierDocumentsById}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// create supplier document value
export const CreateSupplierDocValue = createAsyncThunk(
    'providers/createSupplierDocValue',
    async (params, { dispatch }) => {
        const result = await apiInstance
            .post(DOCUMENT_SERVICE.createSupplierDocValue, params?.data)
            .then(function (response) {
                if (params?.file) {
                    const formData = new FormData();
                    formData.append('id', response?.data?.data?.id);
                    formData.append('option', 'supplier_document');
                    formData.append('file', params?.file);
                    dispatch(UploadImage(formData));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// set supplier document value
export const SetSupplierDocValue = createAsyncThunk(
    'providers/setSupplierDocValue',
    async (params) => {
        const result = await apiInstance
            .put(DOCUMENT_SERVICE.setSupplierDocValue, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const CancelSupplierOrder = createAsyncThunk(
    'providers/cancelSupplierOrder',
    async (id) => {
        const result = await apiInstanceV2
            .put(ORDER_SERVICE.cancelSupplierOrder + id)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);


export const MarkOrderAsDelivered = createAsyncThunk(
    'providers/markOrderAsDelivered',
    async (params) => {
        const response = await apiInstance
            .post(`${ORDER_SERVICE.markOrderAsDelivered}`, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);
